var bookshelf = require("../index-extended"); // ???: ..

module.exports = bookshelf.model("Payment", {
  tableName: "payment",
});
